import { TranslocoService } from '@ngneat/transloco';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BusinessunitModel } from 'projects/core/src/lib/models/businessunit.model';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-businessunit-list',
  templateUrl: './businessunit-list.component.html',
  styleUrls: ['./businessunit-list.component.scss']
})
export class BusinessunitListComponent extends BaseList implements OnInit {

  public businessunits: Array<BusinessunitModel> = [];

  protected rightLoad = 'admin.businessunit.list';
  protected rightNew = 'admin.businessunit.create';
  protected rightOpen = 'admin.businessunit.show';

  public apiUrl = '/businessunits';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService,
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.ui.setPageTitle(this.transloco.translate('common.labels.businessunits'));
    this.loading = true;
    this.api.getModels('businessunits').subscribe({
      next: (result: any) => {
        this.businessunits = [];
        result.data.forEach((businessunit: any) => {
          this.businessunits.push(new BusinessunitModel().deserialize(businessunit));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
